import { useCallback, useEffect } from 'react'

import useSignOut from '~/features/auth/hooks/useSignOut'
import { EClientPath, EMarketingClientPath } from '~/models/api'
import HttpService from '~/services/http'
import {
  isAuthFailureInProgress,
  notifyAuthFailure,
  registerAuthFailureHandler,
  unregisterAuthFailureHandler,
} from '~/services/http/authFailureHandler'
import { store } from '~/store'

const useAxiosInterceptors = () => {
  const { signOut } = useSignOut()
  const setUser = store((state) => state.setUser)

  const handleAuthFailure = useCallback(async () => {
    if (
      !(
        [EClientPath.partnerAuth, EMarketingClientPath.home] as string[]
      ).includes(window.location.pathname)
    ) {
      setUser({
        signInRedirectPath: window.location.pathname as EClientPath,
      })
    }
    await signOut()
  }, [setUser, signOut])

  useEffect(() => {
    registerAuthFailureHandler(handleAuthFailure)
    return unregisterAuthFailureHandler
  }, [handleAuthFailure])

  useEffect(() => {
    HttpService.getAllAvailableInterceptors().then((interceptors) => {
      if (!interceptors) {
        return
      }

      interceptors.map((interceptor) =>
        interceptor.response.use(
          (response) => response,
          async (error) => {
            const alreadyRetried = Boolean(
              (error.config as { authRetry?: boolean } | undefined)?.authRetry,
            )

            if (
              error.response?.status === 401 &&
              alreadyRetried &&
              !isAuthFailureInProgress()
            ) {
              return notifyAuthFailure().then(() => Promise.reject(error))
            }

            return Promise.reject(error)
          },
        ),
      )
    })
  }, [])
}

export default useAxiosInterceptors
